import { Link } from "react-router-dom";
import { KONTAKT, KONTAKT_LANK } from "../../lib/config";
import { Ikon } from "../Ikon";
import { Shead } from "./Sektion";

const STEG: [string, string][] = [
  ["Genomgång", "Vi går igenom hur ni hanterar leverantörsfakturor i dag och vad agenten ska kontrollera."],
  ["Lär av er bokföring", "Ni lämnar en SIE-fil från affärssystemet. Agenten lär sig hur era fakturor brukar konteras, och en ekonom godkänner reglerna."],
  ["Pilot i skuggläge", "Agenten arbetar med era fakturor utan att något skickas till affärssystemet. Ni ser utfallet innan ni bestämmer er."],
];

// Kom igång och kontakt i en sektion: tre steg och knapparna direkt under.
export function KomIgang() {
  return (
    <section className="s" id="kom-igang">
      <div className="wrap">
        <Shead eyebrow="Kom igång" rubrik="Tre steg till en egen pilot" />
        <ol className="igang">
          {STEG.map(([h, p], i) => (
            <li key={h}><span className="n">{String(i + 1).padStart(2, "0")}</span><h3>{h}</h3><p>{p}</p></li>
          ))}
        </ol>
        <div className="cta" id="kontakt">
          <div className="in">
            <div>
              <h2 className="h2">Agenten förbereder. Ni attesterar.</h2>
              <p>Vill ni se hur agenten hanterar era egna leverantörsfakturor? Boka en genomgång. Har ni redan ett konto loggar ni in här.</p>
            </div>
            <div className="ctas">
              {KONTAKT ? <a className="btn primary" href={KONTAKT_LANK}>Boka en genomgång <Ikon namn="arrow" /></a> : null}
              <Link className={"btn" + (KONTAKT ? "" : " primary")} to="/logga-in">Logga in</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
